// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 100vw;
  margin: 0 auto;
}


#loginRes{
  margin-top: 10px;
}

#light #submit{
  background-color: antiquewhite;
  text-align: center;
  margin-top: 10px;
  width: 70px;
  cursor: pointer;
}

#light #token_title{
  font-size: 20px;
  /* font-weight: bold; */
  margin-bottom: 3px;
}
.cs-typing-indicator{
  background-color: #fff0;
}
.cs-message-list{
  background-color: #fff0;

}
#dark .app-container {
  background-color: #242530; 
  /* background-color: red; For browsers that do not support gradients */
  background-image: linear-gradient(#141f31, rgba(23, 10, 40, 0.412)); 

}

#light .app-container {
  background-color:rgb(216 216 216);
    
}
#dark h2 {
  margin: 0;
  text-align: left;
    color: rgb(211, 203, 203);

}
#light h2 {
  margin: 0;
  text-align: left;
  color: black;

}

.switch {
  display: flex;
  gap: 5px;
  width: 150px;
  height: 100px;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

#light .switch label {
  color: black;
}

#dark .switch label {
  color: white;
}

.right {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: start;
}

.responseTime {
  display: flex;
  justify-content: center;
  align-items: self-start;
  border-radius: 10px;
  padding-left: 20PX;
  padding-right: 20px;
  margin-left: 20px;
}

#dark .responseTime{
  background-color: #1b202d;
  color: white;
}

#light .responseTime{
  background-color: #dad8d8;
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;;AAEzB;AACA;EACE,yBAAyB;EACzB,sEAAsE;EACtE,mEAAmE;;AAErE;;AAEA;EACE,iCAAiC;;AAEnC;AACA;EACE,SAAS;EACT,gBAAgB;IACd,yBAAyB;;AAE7B;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,YAAY;;AAEd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd","sourcesContent":[".app-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  max-width: 100vw;\n  margin: 0 auto;\n}\n\n\n#loginRes{\n  margin-top: 10px;\n}\n\n#light #submit{\n  background-color: antiquewhite;\n  text-align: center;\n  margin-top: 10px;\n  width: 70px;\n  cursor: pointer;\n}\n\n#light #token_title{\n  font-size: 20px;\n  /* font-weight: bold; */\n  margin-bottom: 3px;\n}\n.cs-typing-indicator{\n  background-color: #fff0;\n}\n.cs-message-list{\n  background-color: #fff0;\n\n}\n#dark .app-container {\n  background-color: #242530; \n  /* background-color: red; For browsers that do not support gradients */\n  background-image: linear-gradient(#141f31, rgba(23, 10, 40, 0.412)); \n\n}\n\n#light .app-container {\n  background-color:rgb(216 216 216);\n    \n}\n#dark h2 {\n  margin: 0;\n  text-align: left;\n    color: rgb(211, 203, 203);\n\n}\n#light h2 {\n  margin: 0;\n  text-align: left;\n  color: black;\n\n}\n\n.switch {\n  display: flex;\n  gap: 5px;\n  width: 150px;\n  height: 100px;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n}\n\n#light .switch label {\n  color: black;\n}\n\n#dark .switch label {\n  color: white;\n}\n\n.right {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: start;\n}\n\n.responseTime {\n  display: flex;\n  justify-content: center;\n  align-items: self-start;\n  border-radius: 10px;\n  padding-left: 20PX;\n  padding-right: 20px;\n  margin-left: 20px;\n}\n\n#dark .responseTime{\n  background-color: #1b202d;\n  color: white;\n}\n\n#light .responseTime{\n  background-color: #dad8d8;\n  color: black;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
